import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../store/index';
import {
  ActionTypes,
  TypeAction
} from './set-password.actions';
import {
  IPasswordRuleViewModel
} from '../../../core/services/password-policy/interfaces';

export interface PasswordRule {
    type: number;
    info: string | null;
    title: string;
    pattern: RegExp;
}

export interface IState {
    passwordRules: PasswordRule[] | null;
    bannedWordsList: string[],
    miscPasswordValidity: boolean;
    recruitFirstName: string,
    recruitLastName: string,
}

const initialState: IState = {
    passwordRules: null,
    bannedWordsList: [],
    miscPasswordValidity: true,
    recruitFirstName: "",
    recruitLastName: "",
};

export function passwordPolicyReducer(state: IState = initialState, action: TypeAction): IState {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.UPDATE_PASSWORD_POLICY: {
      return Object.assign({}, state, {
          passwordRules: payload.passwordRules.map((ruleViewModel: IPasswordRuleViewModel) => ({
              title: ruleViewModel.title,
              type: ruleViewModel.type,
              info: ruleViewModel.info,
              pattern: RegExp(ruleViewModel.pattern)
          })),
          bannedWordsList: payload.bannedWordsList
        });
    }
    case ActionTypes.UPDATE_RECRUIT_NAMES: {
      return Object.assign({}, state, {
          recruitFirstName: payload.firstName,
          recruitLastName: payload.lastName
        });
    }
    case ActionTypes.SET_MISC_PASSWORD_VALIDITY: {
      return Object.assign({}, state, {
        miscPasswordValidity: payload
      });
    }
    default: {
      return state;
    }
  }
}

export const getPasswordPolicy = createSelector(
    (rootState: IRootState) => {
      return rootState.passwordPolicy;
    },
    (state: IState) => ({rules:state.passwordRules, bannedWordsList: state.bannedWordsList})
  );

export const getMiscPasswordValidity = createSelector(
    (rootState: IRootState) => {
      return rootState.passwordPolicy;
    },
    (state: IState): boolean => state.miscPasswordValidity
  );

export const getRecruitNamesInfo = createSelector(
    (rootState: IRootState) => {
      return rootState.passwordPolicy;
    },
    (state: IState) => ({recruitFirstName:state.recruitFirstName, recruitLastName: state.recruitLastName})
  );